import React, { useEffect, useContext, useState } from 'react';
import { CheckBox } from '../controls'
import { DataContext } from '../../data/DataContext';
import { buildDetTable, getSummary } from '../../data/Services';

const Step3 = () => {

    const { CoopenaeAuto, setCoopenaeAuto } = useContext(DataContext);
    const [arrCober, setArrCober] = useState([]);
    const [total, setTotal] = useState("");
    const [tax, setTax] = useState("");
    const [bonus, setBonus] = useState("");
    const [bonus2, setBonus2] = useState("");
    const [desc, setDesc] = useState("");
    const [dEmission, setDEmission] = useState("");
    const [financing, setFinancing] = useState("");


    useEffect(() => {
        setArrCober(buildDetTable(CoopenaeAuto.catalogs.coverages.coverages, CoopenaeAuto.catalogs.rates.rates, CoopenaeAuto.planId));
        const summary = getSummary(CoopenaeAuto);
        if (summary !== undefined) {
            setCoopenaeAuto({ ...CoopenaeAuto, total: summary.total, tax: summary.tax, bonus: summary.bonus, desc: summary.desc, bonus2: summary.bonus2, pDesc: summary.pDesc, financing: summary.financing });
            setBonus(summary.bonusFormat);
            setDesc(summary.descFormat);
            setBonus2(summary.bonus2Format);
            setDEmission(summary.dEmissionFormat);
            setFinancing(summary.financingFormat);
            setTotal(summary.totalFormat);
            setTax(summary.taxFormat);

        }
    }, []);



    return (
        <div className="step-ca">
            <div className="step-container-ca">
                <div className="mt-10">
                    <span className="sub-title-ca">
                        Detalles de su cotización
            </span>
                </div>
                <div className="mt-5 mb-30">
                    <span className="sub-title2-ca">
                        Te presentamos las coberturas básicas y adicionales de la póliza
            </span>
                </div>
                <table className="table-ca table-ca-t1">
                    <thead>
                        <tr className="thead1-ca">
                            <th colSpan="3">Coberturas de su póliza AUTO LAFISE PLUS</th>
                        </tr>
                        <tr className="thead2-ca">
                            <th className="w50" style={{ textAlign: "left", paddingLeft: "10px" }}>Coberturas</th>
                            <th className="w25">Suma Asegurada</th>
                            <th className="w25">Prima</th>
                        </tr>
                    </thead>
                    <tbody className="table-body-ca">
                        {arrCober.filter(x => x.sa !== "0").map(item => (

                            <tr>
                                <td>{item.nombre}</td>
                                <td style={{ textAlign: "center", whiteSpace: "nowrap" }}>{item.valor}</td>
                                <td style={{ textAlign: "center" }}>{item.prima}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div className="lbl-cober-add-ca">
                    <span>
                        Coberturas adicionales gratuitas al contratar las coberturas A y B
                    </span>
                </div>
                <table className="table-ca table-ca-t2">
                    <thead>
                        <tr className="thead2-ca-t2">
                            <th colSpan="2" className="w50" style={{ textAlign: "left" }} >Coberturas</th>
                            <th className="w25">Suma Asegurada</th>
                            <th className="w25">Prima</th>
                        </tr>
                        <tr className="thead2-ca-t2">
                            <th className="w10"></th>
                            <th className="w40"></th>
                            <th className="w20" style={{ textAlign: "center" }}></th>
                            <th className="w25" style={{ textAlign: "center" }}></th>
                        </tr>
                    </thead>
                    <tbody className="table-body-ca-t2">
                        {arrCober.filter(x => x.sa === "0").map((item, index) => (
                            <tr>
                                <td className="w10" style={{ display: 'flex' }}>
                                    <CheckBox value={true} key={index} />
                                </td>
                                <td>{item.nombre}</td>
                                <td style={{ textAlign: "center" }}>{item.valor}</td>
                                <td style={{ textAlign: "center" }}>{item.prima}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <table className="table-ca table-ca-t3">
                    <tbody className="table-body-ca-t3">
                        <tr colSpan={2} className="tr-detTitle">
                            <td className="w100" style={{ color: "#006BA8", fontSize: "20px", fontWeight: 700 }}>Resumen de prima</td>
                        </tr>
                        <tr className="tr-det">
                            <td className="w70">Prima</td>
                            <td className="w30" style={{ textAlign: "right", paddingRight: 20 }}>{bonus}</td>
                        </tr>
                        <tr className="tr-det">
                            <td className="w70">Descuento</td>
                            <td className="w30" style={{ textAlign: "right", paddingRight: 20 }}>{desc}</td>
                        </tr>
                        <tr className="tr-det">
                            <td className="w70">Prima neta</td>
                            <td className="w30" style={{ textAlign: "right", paddingRight: 20 }}>{bonus2}</td>
                        </tr>
                        <tr className="tr-det">
                            <td className="w70">Derecho emisión</td>
                            <td className="w30" style={{ textAlign: "right", paddingRight: 20 }}>{dEmission}</td>
                        </tr>
                        <tr className="tr-det">
                            <td className="w70">Impuestos</td>
                            <td className="w30" style={{ textAlign: "right", paddingRight: 20 }}>{tax}</td>
                        </tr>
                        <tr className="tr-det">
                            <td className="w70">Financiamiento</td>
                            <td className="w30" style={{ textAlign: "right", paddingRight: 20 }}>{financing}</td>
                        </tr>
                        <tr className="tr-tot">
                            <td className="w70">Total</td>
                            <td className="w30" style={{ textAlign: "right", paddingRight: 20 }}>{total}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Step3;